import type { RouteWithTitle } from '@pbk-web/types';
import { clientFeature, Roles } from '@pbk-web/types';
import { lazy } from 'react';

const insightSpaceRoutes: RouteWithTitle[] = [
  {
    id: 'insights-space',
    path: '/clients/:clientId/insights-space',
    translationKey: 'page.insights-space',
    component: lazy(() => import('../pages/InsightsSpace')),
    permissions: [Roles.TeamLead],
    features: [clientFeature.AI_REVIEWS],
  },
  {
    id: 'ai-review-details',
    path: '/clients/:clientId/insights-space/reviews/:reviewId',
    translationKey: 'page.review-details',
    component: lazy(() => import('../pages/ReviewDetailsPage')),
    permissions: [Roles.TeamLead],
    features: [clientFeature.AI_REVIEWS],
  },
];

export default insightSpaceRoutes;
